var algoliaConfig = {
    api_key : "JI43WIATFL",
    password : "fbcae58eeb0777b82b5fac591cc4d62b",
}

export default algoliaConfig;